<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12" vs-md="12" vs-sm="12">
      <vs-card>
        <h3 class="card-title d-flex">
          Add New Admin Account
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addAdmin = true">Add New Admin</vs-button>
        </h3>
        <p class="card-subtitle">List of all accounts with various operations.</p>

        <table class="table" scope="col">
          <tr>
            <th scope="col">#</th>
            <th scope="col"></th>
            <th scope="col">Accounts Name</th>
            <th scope="col">Email Id</th>
            <th>Phone No.</th>
            <th scope="col">User Type</th>
            <th scope="col"></th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
          <tr
            v-for="(item, index) in all"
            :key="item._id"
            :class="{ 'highlighted-account': item._id === userData._id && item.email === userData.email }"
          >
            <td scope="col">{{ index + 1 }}</td>
            <td scope="col">
              <vs-avatar v-if="item.image == '' || item.image == null" size="50px" :src="require('@/assets/images/users/3.png')" />
              <img v-else :src="item.image" height="50px" />
            </td>
            <td scope="col">{{ item.name }}</td>
            <td scope="col">{{ item.email }}</td>
            <td scope="col">{{ item.phone }}</td>
            <td scope="col">
              <vs-chip color="success" v-if="item.isAdmin">Admin</vs-chip>
              <vs-chip color="success" v-if="!item.isAdmin">User</vs-chip>
            </td>
            <td>
              <vs-button
                class="mr15"
                size="small"
                color="danger"
                icon="delete_sweep"
                @click="
                  deleteAccountPopup = true;
                  itemToDelete = item;
                "
                >Delete</vs-button
              >
            </td>
            <td scope="col">
              <vs-icon style="cursor: pointer" icon="visibility" title="View Details" @click="viewDetails(item)"></vs-icon>
            </td>
            <td scope="col" style="padding-bottom: 1rem">
              <vs-button
                v-if="item._id == userData._id && item.email == userData.email"
                class="edit-profile-button"
                icon="edit"
                title="Edit Profile"
                color="primary"
                @click="$router.push('/edit-profile')"
              />
            </td>
          </tr>
        </table>

        <!-- Code -->
        <vs-popup title="Delete Account" :active.sync="deleteAccountPopup">
          <p>Are you sure you want to delete Account?</p>
          <div>
            <vs-button icon="delete_forever" class="mr-3" @click="deleteAccount">Delete Account</vs-button>
            <vs-button icon="clear" @click="deleteAccountPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>

        <vs-popup class="holamundo" title="Add New Staff" :active.sync="addAdmin">
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Account Name" v-model="admin.name" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input required type="number" label="Account Phone" v-model="admin.phone" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Account Email" v-model="admin.email" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="password" label="Account Password" v-model="admin.password" />
            </vs-col>
            <!-- <vs-col>
              <uploader
                label="Profile Image (Try to use square image Please Don't Upload Video)"
                v-model="admin.image"
                :file="admin.image"
              />
            </vs-col> -->
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="displayImage == ''">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Profile Image (Try to use square image Please Don't Upload Video)</label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                    <input type="file" ref="fileInput" @change="uploadImage($event)" />
                  </div>
                </vs-col>
                <vs-col v-if="displayImage">
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteImage()"></vs-button>
                  <img :src="displayImage" class="imgUp" height="100px" width="150px" />
                  <b v-if="fileName">File Name : {{ fileName }}</b>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-button @click="btnAddAdmin">Add New Admin</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup :title="'Details about - ' + accName" :active.sync="viewPopup">
          <vs-row>
            <vs-col vs-lg="6" vs-xs="12" class="leftHead">
              <h4>Image</h4>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12" class="rightHead">
              <vs-avatar v-if="accImage == ''" size="50px" :src="require('@/assets/images/users/3.png')" />
              <img v-else :src="accImage" height="50px" />
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12" class="leftHead top">
              <h4>Name</h4>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12" class="rightHead top">
              <h5>{{ accName }}</h5>
            </vs-col>
            <hr />
            <vs-col vs-lg="6" vs-xs="12" class="leftHead top">
              <h4>Contact Email Id</h4>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12" class="rightHead top">
              <h5>{{ accEmail }}</h5>
            </vs-col>
            <hr />
            <vs-col vs-lg="6" vs-xs="12" class="leftHead top">
              <h4>Contact Phone</h4>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12" class="rightHead top">
              <h5>{{ accPhone }}</h5>
            </vs-col>
            <hr />
          </vs-row>
        </vs-popup>
        <!-- Code -->
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";
import api from "@/rest.js";
import { API } from "@/common/constants";
// import router from "@/router.js";
export default {
  name: "Accounts",
  data: () => ({
    admin: {
      type: "ADMIN",
    },
    deleteAccountPopup: false,
    viewPopup: false,
    all: [],
    addAdmin: false,
    itemToDelete: {},
    accName: "",
    accEmail: "",
    accPhone: "",
    accImage: "",
    displayImage: "",
    fileName: "",
    userData: {},
  }),
  components: {
    // uploader,
  },
  computed: {},
  methods: {
    setAppUser() {
      const user = localStorage.getItem("admin");
      if (user) {
        this.userData = {
          _id: JSON.parse(user)._id,
          email: JSON.parse(user).email,
        };
      } else {
        this.userData = { _id: "", email: "" };
      }
    },

    deleteAccount() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .delete(`${API.DELETE_ACCOUNT}/${this.$data.itemToDelete._id}`, {}, { headers })
        .then((r) => {
          if (r.status == 200) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.deleteAccountPopup = false;
          this.fetchAllAccounts();
        })
        .catch(() => {});
    },
    fetchAllAccounts() {
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      api
        .get(API.GET_ALL_ADMIN_ACCOUNTS, { headers })
        .then((r) => {
          const allAccounts = r.data;
          const loggedInUser = allAccounts.find((account) => account._id === this.userData._id && account.email === this.userData.email);

          if (loggedInUser) {
            this.$data.all = [loggedInUser, ...allAccounts.filter((account) => account._id !== loggedInUser._id)];
          } else {
            this.$data.all = allAccounts;
          }

          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    viewDetails(i) {
      this.$data.viewPopup = true;
      this.$data.accName = i.name;
      this.$data.accPhone = i.phone;
      this.$data.accImage = i.image;
      this.$data.accEmail = i.email;
    },
    uploadImage(data) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("file", data.target.files[0]);
      formdata.append("Accounts", this.$data.accName);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            this.$data.displayImage = response.data.files[0].url;
            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },
    deleteImage() {
      this.$data.displayImage = "";
    },
    btnAddAdmin() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      this.$data.admin.image = this.$data.displayImage;
      api
        .post(API.ADD_ADMIN, this.$data.admin, { headers })
        .then((r) => {
          this.$data.addAdmin = false;
          this.$data.admin = {
            type: "ADMIN",
          };
          if (r.data.status) {
            this.$vs.notify({
              text: "Added Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              title: "Account Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
          this.fetchAllAccounts();
        })
        .catch((err) => {
          console.log(err);
          this.$vs.notify({
            title: "Account Error",
            text: err.message,
            color: "danger",
            position: "top-right",
          });
        });
    },
  },
  created() {
    this.fetchAllAccounts();
    this.setAppUser();
  },
};
</script>
<style scoped>
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.leftHead h4 {
  font-size: 14px;
  font-weight: 600;
}

.rightHead h5 {
  font-size: 14px;
  font-weight: 400;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.top {
  margin-top: 10px;
}

.edit-profile-button {
  cursor: pointer;
  font-size: 18px;
  border-radius: 50%;
  color: white;
}

.edit-profile-button:hover {
  color: #333;
}

.highlighted-account {
  background-color: #f0f8ff;
  font-weight: bold;
}
</style>
